import { layout } from 'thewest/App.routing'

export const sportFeaturedSegment = layout.component({
    type: 'lima',
    props: {
        verticalSpacing: 'xl',
        fixedRatios: ['16:9'],
        intermediateColumns: 2,
        finalColumns: 4,
        hideTeaser: false,
        hideByline: false,
        hasBackground: true,
        cardLayout: [
            ['teaserWithBackground'],
            ['teaserWithBackground'],
            [
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
                {
                    type: 'landscape',
                    format: 'landscape-paddingNoKicker',
                },
            ],
            ['teaserWithBackground'],
        ],
        cardOrientation: { type: 'Landscape-Portrait' },
        sectionHeader: {
            heading: 'Featured Sport',
            section: 'sport',
        },
        dataDefinitionArgs: {
            type: 'curation',
            name: 'sport-featured',
            offset: 0,
            pageSize: 6,
        },
    },
})
